import { render, staticRenderFns } from "./JoinProject.vue?vue&type=template&id=bb19e7b0&scoped=true"
import script from "./JoinProject.vue?vue&type=script&lang=js"
export * from "./JoinProject.vue?vue&type=script&lang=js"
import style0 from "./JoinProject.vue?vue&type=style&index=0&id=bb19e7b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb19e7b0",
  null
  
)

export default component.exports